export default function generatePassword(passwordLength: number): string {
    const dictionary = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

    return new Array(passwordLength)
        .fill(undefined)
        .map((x) => dictionary[Math.floor(Math.random() * dictionary.length)]).join('')
}
